import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { MailboxFolders, MailboxMessageInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { MailboxMessageDetailSaveModel } from '../models/mailbox-message-detail-save.model';
import { deleteMailboxMessagesMutation } from '../queries/delete-mailbox-message.graphql';
import { DeleteMailboxMessages, DeleteMailboxMessagesVariables } from '../queries/generated/DeleteMailboxMessages';
import { SaveMailboxDetails, SaveMailboxDetailsVariables } from '../queries/generated/SaveMailboxDetails';
import { SaveMailboxMessage, SaveMailboxMessageVariables } from '../queries/generated/SaveMailboxMessage';
import { saveMailboxDetailsMutation } from '../queries/save-mailbox-details.graphql';
import { saveMailboxMessageMutation } from '../queries/save-mailbox-message.graphql';

@Injectable({ providedIn: 'root' })
export class MailboxMessageDetailApiService {
   constructor(private apiService: LcsApiService) {}

   save(
      mailboxMessageDetail: MailboxMessageDetailSaveModel,
      fields: (keyof MailboxMessageInput)[]
   ): Observable<ExecutionResult<SaveMailboxMessage>> {
      return this.apiService.query<SaveMailboxMessage, SaveMailboxMessageVariables>({
         query: saveMailboxMessageMutation,
         variables: {
            mailboxMessage: {
               ...mailboxMessageDetail,
               fields: fields,
            },
         },
      });
   }

   deleteMailboxMessage(mailboxMessageId: number): Observable<ExecutionResult<SaveMailboxMessage>> {
      return this.apiService.query<SaveMailboxMessage, SaveMailboxMessageVariables>({
         query: saveMailboxMessageMutation,
         variables: {
            mailboxMessage: {
               mailboxMessageId: mailboxMessageId,
               isArchived: true,
               fields: ['mailboxMessageId', 'isArchived'],
            },
         },
      });
   }

   markUnreadMailboxMessage(
      mailboxMessageId: number,
      mailboxFolderId?: MailboxFolders | null
   ): Observable<ExecutionResult<SaveMailboxMessage>> {
      const mailboxMessage: MailboxMessageInput = {
         mailboxMessageId,
         isRead: false,
         fields: ['mailboxMessageId', 'isRead'],
      };

      if (mailboxFolderId != null) {
         mailboxMessage.mailboxFolderId = mailboxFolderId;
         mailboxMessage.fields = [...mailboxMessage.fields, 'mailboxFolderId'];
      }

      return this.apiService.query<SaveMailboxMessage, SaveMailboxMessageVariables>({
         query: saveMailboxMessageMutation,
         variables: { mailboxMessage },
      });
   }

   clearMailbox(mailboxMessageIds: number[]): Observable<ExecutionResult<DeleteMailboxMessages>> {
      return this.apiService.query<DeleteMailboxMessages, DeleteMailboxMessagesVariables>({
         query: deleteMailboxMessagesMutation,
         variables: {
            mailboxMessageIds: mailboxMessageIds,
         },
      });
   }

   resetMailbox(mailboxid: number, mailboxMessageIds: number[]): Observable<ExecutionResult<SaveMailboxDetails>> {
      return this.apiService.query<SaveMailboxDetails, SaveMailboxDetailsVariables>({
         query: saveMailboxDetailsMutation,
         variables: {
            mailbox: {
               mailboxId: mailboxid,
               password: null,
               namePromptId: null,
               busyPromptId: null,
               unavailablePromptId2: null,
               temporaryUnavailablePromptId: null,
               fields: [
                  'mailboxId',
                  'password',
                  'namePromptId',
                  'busyPromptId',
                  'unavailablePromptId2',
                  'temporaryUnavailablePromptId',
               ],
            },
            deletedMessageIds: mailboxMessageIds,
            hasDeletedMessages: true,
         },
      });
   }
}
